module.exports = __webpack_public_path__ + "img/ps.ee8bbc88.png";